import { FormElement } from '@uplift/types';
import { ButtonStyleCheckbox, ButtonStyleCheckboxGroup } from '@uplift/ui-v2';
import React from 'react';
import { useStyles } from './styles';

export type MultiSelectProps = {
  element: FormElement;
};

export const MultiSelect: React.VFC<MultiSelectProps> = ({ element }) => {
  const { classes } = useStyles();

  return (
    <ButtonStyleCheckboxGroup
      label=""
      name={element.formElementId}
      className={classes.multiSelects}
      color="secondary"
      required
    >
      {element.formElementAnswers.map(answer => (
        <ButtonStyleCheckbox
          value={answer.formElementAnswerId}
          key={answer.formElementAnswerId}
          label={`${answer.answerText} ${answer.hintText ?? ''}`}
          other={answer.answerType === 'other'}
        />
      ))}
    </ButtonStyleCheckboxGroup>
  );
};
